import React from 'react';

import { ThemeProvider } from '@mui/material';

import { theme } from './styles/themeMui';

type BoltThemeProviderProps = {
  children: React.ReactNode;
};

export function BoltThemeProvider({ children }: React.PropsWithChildren<BoltThemeProviderProps>) {
  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
}
